export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_q02_b.bef4c7ca.png";